<template>
  <div class="container mt-3">
    <section class="bg-white p-4">
      <label>
        <p>
          {{ question }}
        </p>
        <small class="mb-3">
          {{ type }}
        </small>
      </label>

      <b-form-group class="mx-auto mb-3">
        <b-form-checkbox-group
          v-model="selected"
          class="customCheck2"
          button-variant="light"
          :options="options"
          stacked
          buttons
          :disabled="showNextInfo"
        >
        </b-form-checkbox-group>
      </b-form-group>

      <section v-if="showNextInfo" class="text-center mb-5">
        <span
          v-for="item in message"
          :key="item.id"
          :class="item.isCorrect ? 'text-success' : 'text-danger'"
        >
          <p>
            {{ item.question }}
          </p>
          <p class="mb-2">
            {{ item.text }}
          </p>
        </span>
      </section>

      <div class="text-center">
        <small class="">
          Question
          {{ index }}/{{ total }}
        </small>
      </div>
    </section>

    <section class="text-center px-4" v-if="!showNextInfo">
      <b-button
        v-if="!showNextInfo"
        @click="(showNextInfo = true), setFeedback()"
        variant="info"
        class="my-3"
        block
      >
        Done
      </b-button>
      <b-link
        class="text-muted h-auto"
        v-if="index == 1 && !showNextInfo"
        @click="$router.go(-1)"
      >
        Cancel
      </b-link>
    </section>

    <section class="text-center px-4">
      <b-button
        v-if="showNextInfo && index == total"
        @click="$parent.sendData"
        variant="warning"
        class="my-3 h-auto"
        block
      >
        Finish
      </b-button>

      <b-button
        v-else-if="showNextInfo"
        @click="$parent.count += 1"
        variant="warning"
        class="my-3 h-auto"
        block
      >
        Next
      </b-button>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    options: Array,
    question: String,
    type: String,
    total: Number,
    index: Number,
    id: Number
  },
  data() {
    return {
      selected: null,
      showNextInfo: null,
      message: [],
      valueQuest: [],
      correctAnswer: false
    };
  },
  methods: {
    setFeedback() {
      this.options.forEach(element => {
        for (let idx = 0; idx < this.selected.length; idx++) {
          const select = this.selected[idx];
          if (element.value == select) {
            if (element.option_is_correct) {
              this.message.push({
                id: element.id,
                text: "Right! This is the answer.",
                question: element.text,
                isCorrect: true
              });
              this.valueQuest.push(true);
            } else {
              this.message.push({
                id: element.id,
                text: element.explanation,
                question: element.text,
                isCorrect: false
              });
              this.valueQuest.push(false);
            }
          }
        }
      });
      this.isCorrect();
    },
    isCorrect() {
      let countQuest = 0;
      let countSelect = 0;
      this.options.forEach(element => {
        if (element.option_is_correct) {
          countQuest += 1;
        }
      });
      for (let idx = 0; idx < this.valueQuest.length; idx++) {
        const element = this.valueQuest[idx];
        if (element) {
          countSelect += 1;
        }
      }
      if (countQuest == countSelect) {
        this.correctAnswer = true;
      }
    }
  }
};
</script>
<style lang="scss">
.btn-group,
.btn-group-vertical {
  display: block;
}
.customCheck2 label {
  border-color: transparent !important;
  color: var(--color-dark) !important;
  text-align: left;
  font-size: 1.15em;
  border-radius: 30px !important;
  background-color: var(--color-blue-light) !important;
  padding: 10px 10px 10px 15px;
}
.customCheck2 label span {
  //text-transform: uppercase !important;
}
.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 8px !important;
}

.customCheck2 .btn-light:not(:disabled):not(.disabled):active,
.customCheck2 .btn-light:not(:disabled):not(.disabled).active,
.customCheck2 .show > .btn-light.dropdown-toggle {
  color: #f3f4f9 !important;
  background-color: var(--color-main) !important;
}
.customCheck2 .btn:focus,
.btn.focus {
  box-shadow: none !important;
}
.form-group {
  margin-bottom: 0;
}
</style>
